<template>
  <div id="edit-options">
    <b-container>
      <b-row>
        <b-col>
          <h2 align="left">Location:</h2>
        </b-col>
      </b-row>
      <b-card no-body>
        <b-tabs card>
          <b-tab v-for="country in countries" :key="countries.indexOf(country)" :title="country">
            <div>
              <h3 class="sub-title">{{country}}</h3>
              <geo-options :option-key="country"></geo-options>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-container>
    <br />
    <b-container>
      <b-row>
        <b-col>
          <h2 align="left">Options:</h2>
        </b-col>
      </b-row>
      <b-card no-body>
        <b-tabs card>
          <!-- <b-tab title="Grades" active>
            <div class="grades">
              <h3 class="sub-title">Grade Options</h3>
              <options option-key="grades"></options>
            </div>
          </b-tab>-->
          <b-tab title="Feeding" active>
            <div class="feeding">
              <h3 class="sub-title">Feeding Options</h3>
              <options option-key="feeding"></options>
            </div>
          </b-tab>
          <b-tab title="Modules">
            <div class="modules">
              <h3 class="sub-title">Module Options</h3>
              <options option-key="modules"></options>
            </div>
          </b-tab>
          <b-tab title="Languages (Main.)">
            <div>
              <h3 class="sub-title">Languages Options</h3>
              <options option-key="languagesMain"></options>
            </div>
          </b-tab>
          <!-- <b-tab title="Languages (Instruc.)" >
            <div>
              <h3 class="sub-title">Languages of Instruction Options</h3>
              <options option-key="languagesInstruction"></options>
            </div>
          </b-tab>-->
          <b-tab title="Currency">
            <div>
              <h3 class="sub-title">Currency Options</h3>
              <options option-key="currency"></options>
            </div>
          </b-tab>
          <b-tab title="School Type">
            <div>
              <h3 class="sub-title">School Type Options</h3>
              <options option-key="schoolType"></options>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-container>
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Options from "@/components/Options";
import GeoOptions from "@/components/GeoOptions";
import OptionsService from "../services/OptionsService";

export default {
  name: "edit-options",
  components: {
    Options,
    GeoOptions
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      GET_OPTIONS: "optionsList/GET_OPTIONS",
      UPDATE_OPTIONS: "optionsList/UPDATE_OPTIONS"
    })
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "auth/isLoggedIn"
    }),
    countries: {
      get() {
        return this.$store.state.optionsList.countries;
      }
    }
  },
  created() {
    this.GET_OPTIONS();
  }
};
</script>

<style lang="css" scoped>
a:link {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}
.apk-dl {
  color: #fffffa;
}
</style>
